import { render, staticRenderFns } from "./MonitoringSetup.vue?vue&type=template&id=1a411c85&scoped=true"
import script from "./MonitoringSetup.vue?vue&type=script&lang=js"
export * from "./MonitoringSetup.vue?vue&type=script&lang=js"
import style0 from "./MonitoringSetup.vue?vue&type=style&index=0&id=1a411c85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a411c85",
  null
  
)

export default component.exports